
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5kbqa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $87dd8ef876eb2ba0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $87dd8ef876eb2ba0$export$2e2bcd8739ae039 = {
    'ai-mate.chat-error-banner.description': 'Din chatthistorik sparas i upp till 30 dagar.',
    'ai-mate.chat-error-banner.title': 'Starta ny chatt',
    'ai-mate.chat-error.description': "F\xf6rs\xf6k att <btn>l\xe4sa in chatten igen</btn>.",
    'ai-mate.chat-error.rate-limited-description': "Du har n\xe5tt h\xf6gsta antalet f\xf6rfr\xe5gningar. F\xf6rs\xf6k igen senare.",
    'ai-mate.chat-error.rate-limited-title': "F\xf6r m\xe5nga f\xf6rfr\xe5gningar",
    'ai-mate.chat-error.rovo-inactive-description': "Det verkar som att Rovo inte \xe4r aktiverat p\xe5 webbplatsen. <link>St\xe4ller in Rovo</link>",
    'ai-mate.chat-error.rovo-inactive-title': "Rovo \xe4r inaktivt",
    'ai-mate.chat-error.title': 'Vi vet inte vad som gick fel',
    'ai-mate.main-chat.close-chat-button-label': "St\xe4ng",
    'ai-mate.main-chat.maximize-chat-button-label': "Helsk\xe4rm",
    'ai-mate.main-chat.minimize-chat-button-label': "\xc5terst\xe4ll vy",
    'ai-mate.main-chat.new-chat-button-label': 'Ny',
    'ai-mate.main-chat.new-chat-button-label-full-screen': 'Ny chatt',
    'conversation-assistant-button.label': 'Chatt',
    'conversation-assistant-button.rovo-chat-label': 'Rovo-chatt',
    'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Skicka',
    'highlight-actions.rovo-chat-custom-prompt.placeholder': "Fr\xe5ga AI om detta",
    'highlight-actions.rovo-chat-explain-option.text': "F\xf6rklara",
    'highlight-actions.rovo-chat-explain-prompt': "F\xf6rklara detta med en ny formulering och l\xe4gg till mer information, men anv\xe4nd ett l\xe4ttbegripligt spr\xe5k, korta meningar och ge exempel eller definitioner av tekniska termer som anv\xe4nds i den ursprungliga formuleringen.",
    'highlight-actions.rovo-chat-find-resources-option.text': 'Hitta resurser',
    'highlight-actions.rovo-chat-find-resources-prompt': "Hitta endast resurser i organisationskunskapen som ger st\xf6d till meddelandena.",
    'highlight-actions.rovo-chat-give-examples-option.text': 'Ge exempel',
    'highlight-actions.rovo-chat-give-examples-prompt': "Ge exempel p\xe5 detta fr\xe5n organisationsresurser eller allm\xe4n kunskap. Om det saknas resurser att g\xf6ra ett f\xf6rs\xf6k att ge ett metaforiskt exempel som hj\xe4lper en person att f\xf6rst\xe5.",
    'highlight-actions.rovo-chat-give-feedback-option.text': 'Ge feedback',
    'highlight-actions.rovo-chat-give-feedback-prompt': "Ge feedback genom att granska formuleringen. Kommentera ordval, grammatik och skiljetecken. Var positiv och entusiastisk men kom alltid med minst ett f\xf6rslag p\xe5 n\xe5got som kan f\xf6rb\xe4ttras eller f\xf6r\xe4ndras.",
    'highlight-actions.rovo-chat-more-options.tooltip': 'Chattrekommendationer',
    'highlight-actions.rovo-chat-open-chat.tooltip': "\xd6ppna chatt",
    'highlight-actions.rovo-chat-summarize-option.text': 'Sammanfatta',
    'highlight-actions.rovo-chat-summarize-prompt': "Lyft fram de viktigaste punkterna fr\xe5n texten. Fokusera p\xe5 viktig information och hoppa \xf6ver on\xf6diga detaljer. Ge en kortfattad \xf6versikt i ett enda stycke.",
    'highlight-actions.rovo-chat.button-text': 'Chatt',
    'highlight-actions.rovo-chat.button-text-ask-in-chat': "Fr\xe5ga i chatten",
    'horizontal-scroll-container.scroll-left': "Bl\xe4ddra \xe5t v\xe4nster",
    'horizontal-scroll-container.scroll-right': "Bl\xe4ddra \xe5t h\xf6ger"
};

});


//# sourceMappingURL=sv.cd75be52.js.map
